/** Menu click gunshot + bullet-hole flourish. */

import { assetUrl } from "../assetUrl";
import { playBang } from "../game/audio";

export const UI_CLICK_FX_MS = 500;

/** Gunshot at half combat volume, hole at the cursor, resolve after 0.5s. */
export function playUiClickFx(clientX: number, clientY: number): Promise<void> {
  playBang(0.5);

  const hole = document.createElement("img");
  hole.src = assetUrl("sprites/bullet_hole.png");
  hole.alt = "";
  hole.className = "ui-bullet-hole";
  hole.draggable = false;
  hole.style.left = `${clientX}px`;
  hole.style.top = `${clientY}px`;
  document.body.appendChild(hole);
  window.setTimeout(() => hole.remove(), UI_CLICK_FX_MS);

  return new Promise((resolve) => {
    window.setTimeout(resolve, UI_CLICK_FX_MS);
  });
}
